<template lang="html">
    <div class="footer">
        <div class="container">
            <ul>
                <li>
                    <p>产品服务</p>
                </li>
                <li>
                    <router-link to="/software">设备管理软件</router-link>
                </li>
                <li>
                    <router-link to="/app">全医佳App</router-link>
                </li>
                <li>
                    <router-link to="/service">客服系统</router-link>
                </li>
                <li>
                    <router-link to="/cloud">云服务平台</router-link>
                </li>
                <li>
                    <router-link to="/maintenance">维保服务</router-link>
                </li>
                <li>
                    <!-- <router-link to="/supply">供应链金融</router-link> -->
                </li>
            </ul>
            <ul>
                <li>
                    <p>新闻资讯</p>
                </li>
                <li>
                    <router-link to="/news">全医佳新闻</router-link>
                </li>
                <!-- <li>
                    <router-link to="/news">公司新闻</router-link>
                </li> -->
                <li>
                    <router-link to="/news">行业资讯</router-link>
                </li>
            </ul>
            <ul>
                <li>
                    <p>关于我们</p>
                </li>
                <li>
                    <router-link to="/qyj">全医佳</router-link>
                </li>
                <li>
                    <router-link to="/ja">极安</router-link>
                </li>
                <li>
                    <router-link to="/cna">彩超联盟</router-link>
                </li>
                <li>
                    <router-link to="/adv">我们的优势</router-link>
                </li>
            </ul>
            <ul>
                <li>
                    <p @click="see('http://www.beian.miit.gov.cn')">公司软件</p>
                </li>
                <li>
                    <p @click="see('https://doc.qyjmed.com')">Api管理系统</p>
                </li>
                <li>
                    <p @click="see('https://jsd.qyjmed.com')">Git管理系统</p>
                </li>
                <li>
                    <p @click="see('https://pro.qyjmed.com')">项目管理系统</p>
                </li>
                <li>
                    <p @click="see('https://wx-web.qyjmed.com/')">客服订单系统</p>
                </li>
                <li>
                    <p @click="see('https://client.qyjmed.com')">app工程师客服管理系统</p>
                </li>
            </ul>
            <ul>
                <li>
                    <p>联系我们</p>
                    <p>地址：江苏省南京市栖霞区紫东国际创业园B4栋601室</p>
                    <p>联系电话：400-058-0200</p>
                </li>
            </ul>
            <ul>
                <li>
                    <p>微信订阅号</p>
                    <img src="https://static.qyjmed.com/webSite/index/wx.png" alt="">
                </li>
            </ul>
            <hr>
            <p>Copyright©2016  江苏全医佳电子商务有限公司 版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="cursor:pointer" @click="see('http://www.beian.miit.gov.cn')">ICP备案号：苏ICP备160161191</span></p>
            <!-- <p style="padding:5px;cursor:pointer" @click="see('http://www.beian.miit.gov.cn')">苏ICP备160161191</p> -->
            <div style="text-align:center;padding:20px;cursor:pointer">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011302320734" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                    <img src="https://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/client/app/images/img/beian.png" style="float:left;"/>
                    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:white;">苏公网安备 32011302320734号</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'foot',
	methods: {
		see: (e) => {
			window.open(e)
		}
	}
}
</script>

<style lang="scss" scoped>
.footer {
    background: #1A1B1F;
    color: white;
    font-size: 16px;
    .container {
        ul {
            width: 150px;
            display: inline-block;
            vertical-align: top;
            li {
                margin-top: 18px;
                &:first-child {
                    font-size: 22px;
                    margin-top: 50px;
                }
                p {
                    cursor: pointer;
                }
                a {
                    color: white;
                }
            }
            &:nth-child(5) {
                width: 300px;
                p:not(:first-child) {
                    font-size: 14px;
                    margin-top: 18px;
                    line-height: 24px;
                    padding-right: 20px;
                }
            }
            &:nth-child(6) {
                width: 300px;
                li {
                    img {
                        margin-top: 18px;
                    }
                }
            }
        }
        hr {
            border: 0;
            height: 1px;
            background: #F7D6AB35;
            margin: 40px 0 30px;
        }
        > p {
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            a {
                color: white;
            }
            &:last-child {
                margin-top: 10px;
                padding-bottom: 20px;
                cursor: pointer;
            }
        }
    }
}
</style>
